var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJapaneseLangIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30732",
    "data-name": "Group 30732",
    transform: "translate(-9341 -13555)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8709",
    "data-name": "Rectangle 8709",
    width: 28,
    height: 20,
    transform: "translate(9341 13555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8709_-_Outline",
    "data-name": "Rectangle 8709 - Outline",
    d: "M.5.5v19h27V.5H.5M0,0H28V20H0Z",
    transform: "translate(9341 13555)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24221",
    "data-name": "Path 24221",
    d: "M28.333,13.932a6,6,0,1,0-6,6,6,6,0,0,0,6-6Z",
    transform: "translate(9333.047 13551.071)",
    fill: "#bc002d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapaneseLangIcon);
export default __webpack_public_path__ + "static/media/japanese-lang-icon.fddf876cd2dcc14adfd00eca51249318.svg";
export { ForwardRef as ReactComponent };